/**
 * Model for search tournaments
 */
export default class SearchTournamentsModel {
  constructor({
    CategoryId = 0,
    CategoryName = '',
    SportId = 0,
    SportName = '',
    TournamentId = 0,
    TournamentName = ''
  }) {
    /**
     * Category id
     * @type {number}
     */
    this.categoryId = CategoryId;
    /**
     * Category name
     * @type {string}
     */
    this.categoryName = CategoryName;
    /**
     * Sport id
     * @type {number}
     */
    this.sportId = SportId;
    /**
     * Sport name
     * @type {string}
     */
    this.sportName = SportName;
    /**
     * Tournament id
     * @type {number}
     */
    this.tournamentId = TournamentId;
    /**
     * Tournament name
     * @type {string}
     */
    this.tournamentName = TournamentName;
    /**
     * Flag to distinct Tournament search results from event search results
     */
    this.isTournament = true;
  }
}